// extracted by mini-css-extract-plugin
module.exports = {"Report-card-box":"cK","reportCardBox":"cK","report-img-wrap":"cL","reportImgWrap":"cL","report-title":"cM","reportTitle":"cM","report-date":"cN","reportDate":"cN"};